export default __webpack_public_path__ + "static/media/Livestock_icon.d5ae01e1.svg";